import React from 'react'
import styled from "styled-components"

const StyledTable = styled.table`
  border-collapse: collapse;
  width: ${props => props.width};
  box-sizing: border-box;

  thead {
    background-color: #4466ca;
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  thead tr:hover {
    background-color: #4466ca;
    cursor: auto;
  }

  td {
    padding: ${props => props.padding};
    transition: 0.3s;
  }

  tr {
    border-bottom: 1px solid #cdd8f8;
    transition: 0.3s;
  }

  tr:hover {
    background-color: #f6f8ff;
    cursor: ${props => props.cursor};
  }

  tr:last-child {
    border: none;
  }
`

const Table = ({content = "", children, id, width = "auto", cursor = "pointer", padding = "10px 15px"}) => {
    return <StyledTable id={id} width={width} cursor={cursor} padding={padding}>
        {content}{children}
    </StyledTable>
}

export default Table
